import axios from './axios';

export default {
  list() {
    return axios.get('/videos');
  },
  show(videoId) {
    return axios.get(`videos/${videoId}`);
  },
};
